module.exports = __webpack_public_path__ + "static/img/management_icon_gray.07d1773.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/management_icon_gray.svg
// module id = gr2J
// module chunks = 1